/**
 * Create the store with asynchronously loaded reducers
 */

import { applyMiddleware, createStore, Middleware, PreloadedState } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import logger from 'redux-logger';
import reduxThunk from 'redux-thunk';

import { initialState as appInitialState } from 'containers/App/reducer';
import { IReduxState } from 'containers/App/reducer/types';

import appReducer from '../containers/App/reducer';

export default function configureStore(partialState: Partial<IReduxState> = {}) {
  const middlewares: Middleware[] = [reduxThunk];

  // Log all actions in development
  if (process.env.NODE_ENV === 'development' && process.env.REDUX_LOGS) {
    middlewares.push(logger);
  }

  const enhancers = [applyMiddleware(...middlewares)];

  const preloadedState: PreloadedState<IReduxState> = {
    ...appInitialState,
    ...partialState,
  };

  const store = createStore(appReducer, preloadedState, composeWithDevTools(...enhancers));

  return store;
}
